import { FeaturedAlbumsManager } from "@/components/admin/featured-albums/FeaturedAlbumsManager";
import ContainerWrapper from "@/components/ui/ContainerWrapper";
import { FeaturedAlbumsControllerListPlacement } from "@/lib/lutely-api/gen/dtos";
import { Flex, Tabs, Text } from "@radix-ui/themes";
import { createFileRoute } from "@tanstack/react-router";

function FeaturedAlbumsAdminPage() {
  return (
    <ContainerWrapper className="py-8">
      <Flex direction="column" gap="6">
        <Flex direction="column" gap="2">
          <Text size="8" weight="bold">
            Featured Albums
          </Text>
          <Text size="4" color="gray">
            Curate the albums featured on the homepage carousel and the
            marketplace banners.
          </Text>
        </Flex>

        <Tabs.Root defaultValue="marketplace">
          <Tabs.List aria-label="Featured album placements">
            <Tabs.Trigger value="marketplace">Marketplace Banners</Tabs.Trigger>
            <Tabs.Trigger value="homepage">Homepage Carousel</Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content value="marketplace">
            <FeaturedAlbumsManager
              placement={FeaturedAlbumsControllerListPlacement.MARKETPLACE}
            />
          </Tabs.Content>
          <Tabs.Content value="homepage">
            <FeaturedAlbumsManager
              placement={FeaturedAlbumsControllerListPlacement.HOMEPAGE}
            />
          </Tabs.Content>
        </Tabs.Root>
      </Flex>
    </ContainerWrapper>
  );
}

export const Route = createFileRoute("/admin/_adminLayout/featured-albums")({
  component: FeaturedAlbumsAdminPage,
});
